import { getStateWithOnlyOneLevel } from '../../utilities/StateSelectorHelper';

function getState(state) {
  return getStateWithOnlyOneLevel(state, 'dailyquiz');
}

export const getAllDailyQuiz = (state) => getState(state).get('allDailyQuiz');
